import * as React from 'react';
import { Button, Header, Modal, Input } from 'semantic-ui-react';
import MaskedInput from 'react-text-mask'

export interface IRedeemCodeComponentProps {
	code: string;
	codeInfo?: string;
	isInvalid?: boolean;
	isLoading?: boolean;
	onCodeValueChanged?(value);
	onSubmitCode?();
	onGetCodeInfo?();
	onHideCodeInfo?();
}

export const RedeemCodeComponent: React.SFC<IRedeemCodeComponentProps> = (props) => {
	const showModal = props.codeInfo ? true : false;
	const loading = props.isLoading ? true : false;
	const error = props.isInvalid ? true : false;
	return (
		<div>
			<Input className={`theme-action-input`} error={error} placeholder='XXXX-XXXX-XXXX' action >
				<MaskedInput
					mask={[/[A-Z0-9]/, /[A-Z0-9]/, /[A-Z0-9]/, /[A-Z0-9]/, '-', /[A-Z0-9]/, /[A-Z0-9]/, /[A-Z0-9]/, /[A-Z0-9]/, '-', /[A-Z0-9]/, /[A-Z0-9]/, /[A-Z0-9]/, /[A-Z0-9]/]}
					placeholder="XXXX-XXXX-XXXX"
					value={props.code}
					onChange={(event) => props.onCodeValueChanged(event.target.value)}
				/>
				<Button onClick={props.onGetCodeInfo} >Redeem</Button>
			</Input>
			<Modal open={showModal} onClose={props.onHideCodeInfo} size="small" closeIcon>
				<Header content='Redeem Code' />
				<Modal.Content>
					<p>{props.codeInfo}</p>
				</Modal.Content>
				<Modal.Actions>
					<Button primary onClick={props.onSubmitCode} loading={loading} disabled={loading} >Confirm</Button>
				</Modal.Actions>
			</Modal>
		</div>
	);
}



// WEBPACK FOOTER //
// ./src/components/presentational/controls/RedeemCode/index.tsx